// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"da0e005c","592":"74dd11c4","634":"13b85342","806":"f62d8c06"}[chunkId] + ".chunk.css";
};